import * as React from "react";
import { useState } from "react";

import "./styles/RegisterWebinarFormStyles.css";
import { verifyEmail } from "utils/validations";
import { TextInput } from "components";
import Model from "hooks/Model";
import * as moment from "moment";
import Api from "utils/api";

const initPlatforms = {
  soundcloud: "",
  youtube: "",
  mixcloud: "",
  vimeo: "",
};

function RegisterArtistForm() {
  const [alias, setAlias] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [platforms, setPlatforms] = useState(initPlatforms);

  const editPlatform = (label: string, value: string) => {
    setPlatforms((prev) => ({ ...prev, [label]: value }));
  };

  const onRegisterEmail = async (email: string) => {
    try {
      const currentTime = moment().format("x");

      Model.setData("loading", true);
      Model.setData("dialog", { open: false });

      const response = await Api.post("/manychat/registerPartner", {
        alias,
        email,
        link,
        platforms,
        created: currentTime,
        list: "register_artists",
      });

      if (response.status === 200) {
        setAlias("");
        setEmail("");
        setLink("");
        setPlatforms(initPlatforms);
        Model.updateAlerts({
          message:
            "Registramos tus datos éxistosamente, pronto te enviaremos un correo de respuesta.",
          variant: "success",
        });
        Model.logMetaEvent({
          data: [
            {
              event_name: "ArtistFormRegister",
              event_time: parseInt(moment().format("X")),
              action_source: "website",
              original_event_data: {
                event_name: "ArtistFormRegister",
                event_time: parseInt(moment().format("X")),
              },
              user_data: {
                client_user_agent: navigator.userAgent,
                em: [null],
                ph: [null],
              },
            },
          ],
        });
      } else {
        throw response.data;
      }
    } catch (error) {
      Model.updateAlerts({
        message: error?.message || String(error),
        variant: "error",
      });
    } finally {
      Model.setData("loading", false);
    }
  };

  const onSubmit = () => {
    const formatedEmail = email.toLocaleLowerCase().replace(/\s/g, "");

    if (!email || !alias || !link) {
      Model.updateAlerts({
        message:
          "Completa los datos de Nombre, Correo y Link social para inscribirte",
        variant: "error",
      });
    } else if (Object.values(platforms).filter((value) => !!value).length < 1) {
      Model.updateAlerts({
        message: "Ingresa tu perfil en al menos una plataforma para continuar",
        variant: "error",
      });
    } else if (!verifyEmail(formatedEmail)) {
      Model.updateAlerts({
        message: "Ingresa un correo válido para continuar",
        variant: "error",
      });
    } else {
      Model.setData("dialog", {
        open: true,
        title: `${alias}, Antes de continuar ...`,
        text: `¿Aceptas que utilicemos tu correo electrónico (${formatedEmail}) para contactarte sobre los detalles del proceso? Puedes darte de baja en cualquier momento.`,
        txtLeft: "Cancelar",
        fnLeft: () => Model.setData("dialog", { open: false }),
        txtRight: "Acepto",
        fnRight: () => onRegisterEmail(formatedEmail),
      });
    }
  };

  return (
    <div className="register-container">
      <h3 className="register-title">Registro de Artistas</h3>
      <p className="register-description">
        🎟️ ¡Sé parte del futuro del entretenimiento con FROIN!
        <br />
        <br />
        🎤 Estamos abriendo un espacio exclusivo para artistas emergentes del
        mundo del entretenimiento que quieran sumarse a un proyecto
        revolucionario. El <b>único requisito</b> que debes tener es que manejes
        contenido en las plataformas{" "}
        <b>Youtube, SoundCloud, Mixcloud y Vimeo</b> mostrando tu talento para
        que lo impulsemos en nuestra plataforma.
        <br />
        <br />
        🚀 Los <b>beneficios que te traemos</b> son:
        <br />
        ✅ Impulsar tu presencia digital
        <br />
        ✅ Compartir tu contenido para generar mayor reproducciones
        <br />
        ✅ Generar $FROIN por la cantidad de tus visualizaciones
        <br />
        ✅ Utilizar tu saldo de diferentes maneras
        <br />
        ✅ Ser parte de una nueva comunidad que participará en nuevas dinámicas
        con beneficios exclusivos.
        <br />
        <br />⏳ <b>¡Cupo limitado!</b> Pronto cerraremos las puertas a nuevas
        postulaciones. No te quedes fuera, deja tu datos y nuestro equipo te
        dará respuesta.
        <br />
        <br />
        🤑 <b>RECUERDA QUE EL SERVICIO ES GRATUITO</b>, aprovecha esta
        oportunidad por tiempo limitado.
        <br />
        <br />
        🔥 Anímate a unirte al proyecto para ser parte de nuestro futuro, solo
        debes ingresar los siguientes datos con al menos un link de alguna de
        las plataformas streaming. Nuestro equipo revisará tu perfil para
        publicarlo lo más pronto y te contactará para resolver cualquier duda.
        <br />
        <br />
        🤝 Al inscribirte aceptas nuestros{" "}
        <a href="https://froin.club/legal?document=artistContract">
          Términos y Condiciones
        </a>
        , si quieres conocer más detalle de la propuesta te invitamos a que leas
        la{" "}
        <a href="https://froin.club/legal?document=artist">
          presentación completa aquí
        </a>
        .
      </p>

      <div className="register-row-submit">
        <div className="cont-sub-row-submit">
          <div className="sub-row-submit">
            <TextInput
              value={alias}
              onChange={setAlias}
              placeholder="Nombre*"
              customClassName="input-info"
            />
            <TextInput
              customClassName="input-info"
              value={email}
              onChange={setEmail}
              placeholder="Correo*"
            />
            <TextInput
              value={link}
              onChange={setLink}
              placeholder="Link social*"
              customClassName="input-info"
            />
          </div>
          <div className="sub-row-submit">
            <TextInput
              customClassName="input-info"
              value={platforms.soundcloud}
              onChange={(value: string) => editPlatform("soundcloud", value)}
              placeholder="Soundcloud"
            />
            <TextInput
              value={platforms.youtube}
              onChange={(value: string) => editPlatform("youtube", value)}
              customClassName="input-info"
              placeholder="YouTube"
            />
          </div>
          <div className="sub-row-submit">
            <TextInput
              customClassName="input-info"
              value={platforms.mixcloud}
              onChange={(value: string) => editPlatform("mixcloud", value)}
              placeholder="MixCloud"
            />
            <TextInput
              value={platforms.vimeo}
              onChange={(value: string) => editPlatform("vimeo", value)}
              customClassName="input-info"
              placeholder="Vimeo"
            />
          </div>
        </div>
        <button className="register-btn-submit" onClick={onSubmit}>
          Enviar registro
        </button>
      </div>
    </div>
  );
}

export default RegisterArtistForm;
